import { audioContext } from './context';
import { SheetLibrary } from './voice';

let sheets: Promise<SheetLibrary | undefined> | undefined;

/** The recorded voice (public/voice/manifest.json), loaded once per page; none: browser voice. */
export const recordedSheets = () =>
  (sheets ??= SheetLibrary.load(`${import.meta.env.BASE_URL}voice/manifest.json`, audioContext));
